import { render, staticRenderFns } from "./TaskListSingletonMenus.vue?vue&type=template&id=7f9dcd7f"
import script from "./TaskListSingletonMenus.vue?vue&type=script&lang=ts"
export * from "./TaskListSingletonMenus.vue?vue&type=script&lang=ts"
import style0 from "./TaskListSingletonMenus.vue?vue&type=style&index=0&id=7f9dcd7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports